import { Grid2 } from "@mui/material";
import { useEffect } from "react";
import useUIBp from "../../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../../store/slices/UI";
import CheckButton from "../../../../../../UI/Specialized/Check";

export const bkpNewReposArrayId = "bkpNewRepos";

const BackupNewRepos = ({ login }) => {
  const { dispatch } = useUIBp();

  useEffect(() => {
    return () => {
      dispatch(UIactions.clear(bkpNewReposArrayId + login));
    };
  }, [dispatch, login]);

  return (
    <Grid2 container {...{ size: 12, alignItems: "center" }}>
      <CheckButton
        {...{
          id: login,
          arrayId: bkpNewReposArrayId,
          size: "auto",
          fontSize: 1,
          clearOnExit: true,
        }}
      />
    </Grid2>
  );
};

export default BackupNewRepos;
